var _defs, _circle, _g, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEuFlagCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "European Union") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "s",
    points: "0.000,-1.300 0.292,-0.402 1.236,-0.402 0.472,0.153 0.764,1.052 0.000,0.497 -0.764,1.052 -0.472,0.153 -1.236,-0.402 -0.292,-0.402"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#003399"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFCC00"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 8,
    y: 3
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 10.5,
    y: 3.67
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 12.33,
    y: 5.5
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 13,
    y: 8
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 12.33,
    y: 10.5
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 10.5,
    y: 12.33
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 8,
    y: 13
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 5.5,
    y: 12.33
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 3.67,
    y: 10.5
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 3,
    y: 8
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 3.67,
    y: 5.5
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 5.5,
    y: 3.67
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.85,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuFlagCircle);
export default __webpack_public_path__ + "static/media/eu-flag-circle.55789dcf4eb91e369c93956bcea8bcf8.svg";
export { ForwardRef as ReactComponent };